import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'
import { ForgotShadcnComponent } from 'app/components/forgot/ForgotShadcnComponent'
import { useForgot } from 'app/components/forgot/useForgot'

const validator = withZod(
  z.object({ email: z.string().min(1, { message: 'Email is required' }).email('Must be a valid email') }),
)

export default function Forgot() {
  const { email, success, error, isSubmitting, setEmail, onSubmit } = useForgot()

  return (
    <ForgotShadcnComponent
      email={email}
      success={success}
      error={error}
      isSubmitting={isSubmitting}
      validator={validator}
      setEmail={setEmail}
      onSubmit={onSubmit}
    />
  )
}
